const AREAS = [
    "Administración",
    "Comercio y Bienes de Consumo",
    "Diseño",
    "Educación",
    "Farmacéutica o Biotecnología",
    "Finanzas",
    "Gestión de Proyectos",
    "Gobierno / Sector Público",
    "Industria Automotriz",
    "Ingeniería",
    "Investigación y Desarrollo",
    "Legal",
    "Logística",
    "Manufactura",
    "Marketing",
    "Medios de Comunicación",
    "Recursos Humanos",
    "Relaciones Internacionales",
    "Salud",
    "Servicios",
    "Tecnologías de la Información",
    "Telecomunicaciones",
    "Ventas",
];

// Opciones base comunes a cualquier área
const BASE_PROCESSES = [
    { value: "reporting", label: "Reportes / KPIs" },
    { value: "automation", label: "Automatizaciones / Flujos" },
    { value: "documents", label: "Documentos / Contratos" },
    { value: "integrations", label: "Integraciones / API" },
    { value: "security", label: "Seguridad / Accesos" },
    { value: "it_support", label: "Soporte técnico / TI" },
    { value: "hr", label: "Recursos Humanos / Nómina" },
    { value: "accounting", label: "Contabilidad / Impuestos" },
    { value: "crm", label: "Leads / CRM" },
    { value: "marketing", label: "Marketing / Anuncios" },
];

// Específicos por área
const AREA_PROCESSES = {
    "Administración": [
        { value: "approvals", label: "Aprobaciones y firmas" },
        { value: "budget_control", label: "Control presupuestal" },
        { value: "expenses_travel", label: "Gastos y viáticos" },
        { value: "vendors_mgmt", label: "Gestión de proveedores" },
        { value: "records", label: "Archivo / Gestión documental" },
        { value: "internal_audit", label: "Auditoría interna" },
    ],
    "Comercio y Bienes de Consumo": [
        { value: "merchandising", label: "Merchandising" },
        { value: "pricing_promos", label: "Precios y promociones" },
        { value: "replenishment", label: "Reposición de inventario" },
        { value: "trade_marketing", label: "Trade marketing" },
        { value: "wholesale_orders", label: "Pedidos mayoristas" },
        { value: "stores_ops", label: "Operación de tiendas / POS" },
    ],
    "Diseño": [
        { value: "briefs", label: "Briefs y requerimientos" },
        { value: "versioning", label: "Versionado y control de cambios" },
        { value: "reviews", label: "Revisiones y aprobaciones" },
        { value: "creative_pipeline", label: "Pipeline creativo" },
        { value: "dam", label: "Gestión de assets (DAM)" },
        { value: "handoff", label: "Handoff a desarrollo / producción" },
    ],
    "Educación": [
        { value: "enrollment", label: "Inscripciones y control escolar" },
        { value: "courses", label: "Gestión de cursos / horarios" },
        { value: "assessment", label: "Evaluaciones y calificaciones" },
        { value: "attendance", label: "Asistencia" },
        { value: "comms", label: "Comunicación con alumnos / padres" },
        { value: "certificates", label: "Certificados y constancias" },
    ],
    "Farmacéutica o Biotecnología": [
        { value: "regulatory", label: "Regulatorio / Cumplimiento" },
        { value: "traceability", label: "Trazabilidad y lotes" },
        { value: "pharmacovigilance", label: "Farmacovigilancia" },
        { value: "quality_control", label: "Control de calidad" },
        { value: "clinical_docs", label: "Documentación clínica" },
        { value: "change_control", label: "Aprobación de cambios" },
    ],
    "Finanzas": [
        { value: "bank_recon", label: "Conciliación bancaria" },
        { value: "ap", label: "Cuentas por pagar" },
        { value: "ar", label: "Cuentas por cobrar" },
        { value: "budget_forecast", label: "Presupuestos y forecast" },
        { value: "closing", label: "Cierre contable" },
        { value: "fin_reports", label: "Reportes financieros" },
    ],
    "Gestión de Proyectos": [
        { value: "planning", label: "Planeación y estimaciones" },
        { value: "resource_alloc", label: "Asignación de recursos" },
        { value: "milestones", label: "Seguimiento de hitos" },
        { value: "risks", label: "Gestión de riesgos" },
        { value: "status_reports", label: "Reportes de estado" },
        { value: "retros", label: "Retrospectivas y lecciones" },
    ],
    "Gobierno / Sector Público": [
        { value: "tenders", label: "Licitaciones / Compras públicas" },
        { value: "cases", label: "Trámites y expedientes" },
        { value: "transparency", label: "Transparencia y rendición de cuentas" },
        { value: "budget_control_public", label: "Control presupuestal" },
        { value: "citizen_care", label: "Atención ciudadana" },
        { value: "esign", label: "Firma electrónica / Oficialía de partes" },
    ],
    "Industria Automotriz": [
        { value: "production_ctrl", label: "Control de producción" },
        { value: "supply_chain", label: "Cadena de suministro" },
        { value: "ppap_quality", label: "Calidad (PPAP)" },
        { value: "maintenance", label: "Mantenimiento preventivo" },
        { value: "logistics_auto", label: "Logística" },
        { value: "vin_traceability", label: "Trazabilidad (VIN)" },
    ],
    "Ingeniería": [
        { value: "ecn_eco", label: "Control de cambios (ECN/ECO)" },
        { value: "cad_bom", label: "CAD / BOM" },
        { value: "requirements", label: "Gestión de requerimientos" },
        { value: "testing", label: "Pruebas y validación" },
        { value: "issues", label: "Gestión de incidencias" },
        { value: "tech_docs", label: "Documentación técnica" },
    ],
    "Investigación y Desarrollo": [
        { value: "rnd_projects", label: "Proyectos I+D" },
        { value: "protocols", label: "Protocolos / Experimentos" },
        { value: "eln", label: "ELN (registro de laboratorio)" },
        { value: "ip", label: "Propiedad intelectual" },
        { value: "ethics", label: "Revisión ética" },
        { value: "data_analysis", label: "Análisis de datos" },
    ],
    "Legal": [
        { value: "contracts", label: "Gestión de contratos" },
        { value: "deadlines", label: "Control de vencimientos" },
        { value: "due_diligence", label: "Due diligence" },
        { value: "clauses_db", label: "Base de cláusulas" },
        { value: "litigation", label: "Litigios / Expedientes" },
        { value: "e_sign", label: "Firmas electrónicas" },
    ],
    "Logística": [
        { value: "routing", label: "Ruteo y planeación" },
        { value: "shipment_tracking", label: "Seguimiento de envíos" },
        { value: "wms", label: "WMS / Almacén" },
        { value: "cross_docking", label: "Cross-docking" },
        { value: "returns_log", label: "Devoluciones" },
        { value: "freight_control", label: "Control de fletes" },
    ],
    "Manufactura": [
        { value: "mrp", label: "Planeación (MRP)" },
        { value: "work_orders", label: "Órdenes de producción" },
        { value: "oee", label: "OEE / Eficiencia" },
        { value: "scrap", label: "Scrap / Merma" },
        { value: "tpm", label: "Mantenimiento (TPM)" },
        { value: "traceability_manu", label: "Trazabilidad" },
    ],
    "Marketing": [
        { value: "campaigns", label: "Campañas" },
        { value: "calendar", label: "Calendario de contenidos" },
        { value: "leads_mkt", label: "Leads y nurturing" },
        { value: "attribution", label: "Atribución" },
        { value: "ab_testing", label: "A/B testing" },
        { value: "social_seo", label: "Social / SEO / SEM" },
    ],
    "Medios de Comunicación": [
        { value: "editorial", label: "Calendario editorial" },
        { value: "rights", label: "Derechos / Licencias" },
        { value: "ingest", label: "Ingesta y catalogación" },
        { value: "reviews_media", label: "Revisión y aprobación" },
        { value: "multichannel", label: "Distribución multicanal" },
        { value: "monetization", label: "Monetización / Pauta" },
    ],
    "Recursos Humanos": [
        { value: "ats", label: "Reclutamiento (ATS)" },
        { value: "onboarding", label: "Onboarding" },
        { value: "payroll", label: "Nómina" },
        { value: "performance", label: "Evaluación de desempeño" },
        { value: "lms", label: "Capacitación / LMS" },
        { value: "engagement", label: "Clima / Encuestas" },
    ],
    "Relaciones Internacionales": [
        { value: "alliances", label: "Convenios / Alianzas" },
        { value: "mobility", label: "Movilidad / Intercambio" },
        { value: "events", label: "Gestión de eventos" },
        { value: "multilingual_comms", label: "Comunicación multilingüe" },
        { value: "intl_compliance", label: "Cumplimiento internacional" },
        { value: "impact_reports", label: "Reportes de impacto" },
    ],
    "Salud": [
        { value: "appointments", label: "Agenda de citas" },
        { value: "emr", label: "Historia clínica (EMR)" },
        { value: "medical_billing", label: "Facturación médica" },
        { value: "supplies", label: "Inventario de insumos" },
        { value: "followups", label: "Seguimiento de pacientes" },
        { value: "telemedicine", label: "Telemedicina" },
    ],
    "Servicios": [
        { value: "work_orders_srv", label: "Órdenes de trabajo" },
        { value: "dispatch", label: "Despacho / Asignación de técnicos" },
        { value: "sla", label: "SLA y tiempos de atención" },
        { value: "recurring_billing", label: "Facturación recurrente" },
        { value: "csat", label: "Encuestas de satisfacción" },
        { value: "contracts_srv", label: "Contratos de servicio" },
    ],
    "Tecnologías de la Información": [
        { value: "itsm", label: "Mesa de ayuda / ITSM" },
        { value: "cmdb", label: "CMDB / Inventario TI" },
        { value: "devops", label: "Despliegues / DevOps" },
        { value: "monitoring", label: "Monitoreo" },
        { value: "access_mgmt", label: "Gestión de accesos" },
        { value: "security_ops", label: "Seguridad / Parches" },
    ],
    "Telecomunicaciones": [
        { value: "provisioning", label: "Provisión / Activación" },
        { value: "noc", label: "NOC / Monitoreo" },
        { value: "billing_telco", label: "Facturación / Planes" },
        { value: "portability", label: "Portabilidad" },
        { value: "network_mgmt", label: "Gestión de redes" },
        { value: "post_sale_telco", label: "Atención postventa" },
    ],
    "Ventas": [
        { value: "opportunities", label: "Oportunidades (CRM)" },
        { value: "quotes", label: "Cotizaciones" },
        { value: "orders", label: "Pedidos" },
        { value: "commissions", label: "Comisiones" },
        { value: "forecast", label: "Forecast de ventas" },
        { value: "ecom_integrations", label: "Integraciones e-commerce" },
    ]
};

export { AREAS, BASE_PROCESSES, AREA_PROCESSES };
